import styled from 'styled-components'
import { COLORS } from 'consts/colors'
import {
  customizeVerticalScrollbarThumbMixin,
  setCommonBorderStyles
} from 'styles/mixins'
import { MOBILE_SIZE_BREAKPOINT } from 'consts'

interface ITextAreaInputWrapperProps {
  $isError?: boolean
  $isWarning?: boolean
  $maxHeight: number
  $minHeight?: number
  $hasBorderStyles?: boolean
}

export const TextAreaInputWrapper = styled.textarea<ITextAreaInputWrapperProps>`
  padding: 12px;
  height: ${({ $minHeight }) => ($minHeight ? $minHeight : 175)}px;
  min-height: ${({ $minHeight }) => ($minHeight ? `${$minHeight}px` : 'auto')};
  max-height: ${({ $maxHeight }) => $maxHeight}px;

  font-family: inherit;
  font-size: 14px;
  font-weight: 500;
  resize: none;
  width: 100%;
  border-radius: 4px;

  overflow-y: hidden; // Set default to hidden
  color: ${COLORS.secondarySemiDark};
  background-color: ${COLORS.white};

  ${customizeVerticalScrollbarThumbMixin()}
  ${({ $isError, $isWarning, $hasBorderStyles }) =>
    $hasBorderStyles && setCommonBorderStyles($isError, $isWarning)}

  &::placeholder {
    color: ${COLORS.secondary};
    font-size: 14px;
    font-weight: 500;
  }

  @media (max-width: ${MOBILE_SIZE_BREAKPOINT}px) {
    min-width: 50px;
    width: 100%;
  }

  transition:
    color 0.3s,
    border-color 0.3s,
    box-shadow 0.3s;
`
